module.exports = __webpack_public_path__ + "static/media/Dual_Reflect_6511.2836f339.jpg";